import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import CustomizeFavorites from '../CustomizeFavorites/CustomizeFavorites';

/**
 * Wrapper component for the rest of the page's contents
 * @returns Contents component
 */
const Contents = props => {
	return (
		<Box component='main' sx={{ flexGrow: 1, p: 3, width: '100%' }}>
			<Toolbar />
			{props.showFavorites && (
				<CustomizeFavorites
					onClickHideFavorites={props.onClickHideFavorites}
				/>
			)}
			{props.children}
		</Box>
	);
};

Contents.propTypes = {
	children: PropTypes.node,
};

export default Contents;
